/* eslint-disable max-len, no-underscore-dangle */
const DomPositionTracker = require('../../../utils/domPositionTracker.es6').default;
const NewHeader = require('../../react/PageHeader/NewHeader').default;

/**
 * HoverCallout
 * Very simple, but very flexible ;)
 *
 * @param contentFunction renders content
 * @param targetElement
 * @param offsetsAndDimensions
 * @param alignment
 * @param options
 * @constructor
 */
function HoverCallout(contentFunction, targetElement, offsetsAndDimensions, alignment, options = {}) {

  const customClass = (options && options.className) || '';

  const tempElemnt = document.createElement('DIV');
  tempElemnt.innerHTML =
    `<div data-component='hover-callout' class="media-not-desktop no-print ${customClass}"></div>`;

  this._element = tempElemnt.firstChild;
  this._destroyBoundWithThis = this.destroy.bind(this);
  this._contentFunction = contentFunction;

  // todo we should use object composition to add this tracking ability trait to hover box
  this._domPositionTracker = new DomPositionTracker(this._element, targetElement, offsetsAndDimensions);
  const header = document.querySelector(NewHeader.pageHeaderElementQuery);
  if (header) {
    header.addEventListener(NewHeader.HEADER_RENDERED, () => {
      this._domPositionTracker.updatePosition();
    });
  }

  this._element.setAttribute('data-alignment', alignment);


  if (options.customStyles) {
    for (const style in options.customStyles) {
      if (options.customStyles.hasOwnProperty(style)) {
        this._element.style[style] = options.customStyles[style];
      }
    }
  }

}

HoverCallout.prototype = {
  /**
   * Shows the element and adds listeners
   */
  show() {
    document.body.appendChild(this._element);
    this._contentFunction(this._element);
  },

  destroy() {
    this._element.parentElement.removeChild(this._element);
  },
  /**
   * returns the actual dom of the whole component
   * @returns {Node}
   */
  getElement() {
    return this._element;
  }
};

HoverCallout.ALIGNMENT_TOP = 'top';
HoverCallout.ALIGNMENT_RIGHT = 'right';
HoverCallout.ALIGNMENT_BOTTOM = 'bottom';
HoverCallout.ALIGNMENT_LEFT = 'left';
HoverCallout.ALIGNMENT_OFFSET = 15; // Additional pixels to offset position based on the :before value of the element

module.exports = HoverCallout;

